// components/CardStatus.jsx
import React from "react";
import styles from "../ModalDetailReservationV2.module.css";

const CardStatus = ({ label, color = "bg-success" }) => {
  // Map the color classes to our CSS module classes
  const getStatusClass = (colorClass) => {
    switch (colorClass) {
      case "bg-blue-light":
        return styles.cardStatusBlueLight;
      case "bg-success":
        return styles.cardStatusSuccess;
      case "bg-info":
        return styles.cardStatusInfo;
      case "bg-orange":
        return styles.cardStatusOrange;
      case "bg-danger":
        return styles.cardStatusDanger;
      case "bg-warning":
        return styles.cardStatusWarning;
      case "bg-secondary":
        return styles.cardStatusSecondary;
      default:
        return styles.cardStatusSuccess;
    }
  };

  return (
    <div className={`${styles.cardStatus} ${getStatusClass(color)}`}>
      <p className={styles.cardStatusText}>{label}</p>
    </div>
  );
};

export default CardStatus;
